import { Close } from "@mui/icons-material";
import { Box, IconButton, Modal, Typography } from "@mui/material";
import { ToastAndModalSetters } from "../app/types";
import { ReactNode } from "react";
import { useAppSelector } from "../app/hooks";
import {
  selectModalBoxStyle,
  selectModalShow,
  selectModalTitle,
  setShowModal
} from "./modalSlice";
import { useDispatch } from "react-redux";

type SIMPLModalProps = ToastAndModalSetters & {
  hideCloseButton?: boolean;
  children?: ReactNode;
};

export const SIMPLModal = ({ hideCloseButton, children }: SIMPLModalProps) => {
  const content = children ? children : <div>Empty Modal</div>;
  const open = useAppSelector(selectModalShow);
  const modalBoxStyle = useAppSelector(selectModalBoxStyle);
  const modalTitle = useAppSelector(selectModalTitle);
  const dispatch = useDispatch();
  return (
    <Modal
      open={open}
      onClose={() => {
        dispatch(setShowModal(false));
      }}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: 0,
        flex: 1
      }}
    >
      <Box
        sx={{
          minHeight: 0,
          bgcolor: "background.paper",
          boxShadow: 24,
          overflow: "hidden",
          display: "flex",
          width: "80%",
          minWidth: "528px",
          maxWidth: "100%",
          maxHeight: "90vh",
          flexDirection: "column",
          ...modalBoxStyle
        }}
      >
        {(!hideCloseButton || modalTitle) && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "background.paper",
              zIndex: 1,
              px: 1,
              py: 0.5
            }}
          >
            <Box sx={{ flex: 1 }} />
            {modalTitle ? (
              <Typography
                variant="h6"
                component="h2"
                sx={{
                  flex: "0 0 auto",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "100%"
                }}
              >
                {modalTitle}
              </Typography>
            ) : null}
            <Box
              sx={{
                flex: 1,
                display: "flex",
                justifyContent: "flex-end"
              }}
            >
              {!hideCloseButton && (
                <IconButton
                  onClick={() => {
                    if (setShowModal) {
                      dispatch(setShowModal(false));
                    }
                  }}
                >
                  <Close />
                </IconButton>
              )}
            </Box>
          </Box>
        )}
        <Box sx={{ overflowY: "auto", minHeight: 0, flex: 1 }}>{content}</Box>
      </Box>
    </Modal>
  );
}
